import React, { useState, useEffect } from "react";
import LeftSideNavigation from "../../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import { AddItemMainReusable } from "../../../../vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/MenuSetup/AddItem/AddItemChain";
import HomeReusableTopBarNavigation from "../../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { AmealioLoader } from "../../../../Loader/AmealioLoader";
import { get_item_details_from_item_id } from "../../../../../store/actions/SuperAdminActions/adminCreateCatalogue";

function AddItemChain(props) {
  const [step, setStep] = useState(1);

  useEffect(() => {
    if (props && props.activeItemId && props.activeItemId.length > 2) {
      const token = props.auth.user.accessToken;
      props.get_item_details_from_item_id(props.activeItemId, token);
    }
  }, [props.activeItemId]);

  useEffect(() => {
    if (Object.entries(props.menuCategoryItems).length !== 0) {
      setStep(props.menuCategoryItems.runingTrack);
    }
  }, [props.menuCategoryItems && props.menuCategoryItems.runingTrack]);

  return (
    <React.Fragment>
      {props.auth.loader ? (
        <AmealioLoader />
      ) : (
        <React.Fragment>
          <div className="container-fluid">
            <div className="row superadmin-pending-chains-vendor">
              <div className="left-side-panel">
                <LeftSideNavigation displayLink={1} />
              </div>
              <div className="super-admin-right-side-panel">
                <HomeReusableTopBarNavigation />
                <AddItemMainReusable
                  step={step}
                  setStep={setStep}
                  menuCategoryItems={props.menuCategoryItems}
                />
              </div>
            </div>
          </div>
        </React.Fragment>
      )}
    </React.Fragment>
  );
}

AddItemChain.propTypes = {
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors && state.errors.errors,
  menuCategoryItems: state.commonSuperAdmin.menuCategoryItems,
  activeItemId: state.commonSuperAdmin.activeItemId,
});

export default connect(mapStateToProps, { get_item_details_from_item_id })(
  AddItemChain
);
